// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconListCheck, IconUserPlus, IconFileInfo, IconAlignCenter, IconBoxModel2, IconBoxModel, IconList } from '@tabler/icons';

// constant
const icons = {
    IconListCheck,
    IconUserPlus,
    IconFileInfo,
    IconAlignCenter,
    IconBoxModel2,
    IconBoxModel,
    IconList
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const managerAdvanceGroup = {
    id: 'manager-advance-group',
    type: 'group',
    children: [
        {
            id: 'manager-advance',
            title: <FormattedMessage id="advance" />,
            type: 'collapse',
            breadcrumbs: false,
            icon: icons.IconBoxModel2,
            children: [
                {
                    id: 'new-advance',
                    title: <FormattedMessage id="new-advance" />,
                    type: 'item',
                    url: '/advance-form',
                    icon: icons.IconFilePlus,
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'my-advances',
                    title: <FormattedMessage id="my-advances" />,
                    type: 'item',
                    url: '/advance-list?type=my_advances',
                    icon: icons.IconFiles,
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'waiting-my-approve-advance',
                    title: <FormattedMessage id="waiting-my-approve-advance" />,
                    type: 'item',
                    url: '/advance-list?type=waiting_my_approve',
                    icon: icons.IconLoader,
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'my-approved-advances',
                    title: <FormattedMessage id="my-approved-advances" />,
                    type: 'item',
                    url: '/advance-list?type=my-approved',
                    icon: icons.IconSubtask,
                    breadcrumbs: false,
                    visible: true
                },
            ]
        },
    ]
};

export default managerAdvanceGroup;
